(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-external/assets/javascripts/components/play-external-prompt.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-external/assets/javascripts/components/play-external-prompt.js');
"use strict";


const {
  useRef
} = React;
const {
  useSelector
} = ReactRedux;
const {
  selectEngineDefinition
} = svs.components.tipsen.engine.selectors;
const Button = svs.ui.ReactButton;
const {
  useQueryParam
} = svs.components.lbUtils;
const {
  PARAM_MARKETPLACE_GAME_ID
} = svs.components.sport.tipsenShared;
const PlayExternalPrompt = _ref => {
  let {
    isLoggedIn
  } = _ref;
  const formUpload = useRef();
  const engine = useSelector(selectEngineDefinition);
  const marketplaceGameId = useQueryParam(PARAM_MARKETPLACE_GAME_ID);
  const marketplaceParam = marketplaceGameId ? "&".concat(PARAM_MARKETPLACE_GAME_ID, "=").concat(marketplaceGameId) : undefined;
  const uploadAction = "".concat(svs.core.urlMapping.get('external_systems_upload'), "?product=").concat(engine.drawProductIds[0]).concat(marketplaceParam ? marketplaceParam : '');
  const handleUpload = () => {
    formUpload.current.submit();
    formUpload.current.reset();
  };
  const handleSignIn = () => {
    svs.components.customer_login.login();
  };
  return React.createElement("div", {
    className: "external-prompt elevation-100 paper paper-sport"
  }, React.createElement("h1", {
    className: "f-800"
  }, "Externa Systemspel"), React.createElement("h2", {
    className: "f-medium f-500"
  }, isLoggedIn ? 'Ladda upp ett spel genom en textfil' : 'Logga in för att ladda upp ditt spel'), isLoggedIn ? React.createElement("form", {
    action: uploadAction,
    className: "js-default-promo-form-upload",
    encType: "multipart/form-data",
    method: "post",
    ref: formUpload
  }, React.createElement("input", {
    accept: "text/plain",
    className: "external-uploadInput",
    id: "file",
    name: "user-rows",
    onChange: handleUpload,
    type: "file"
  }), React.createElement("label", {
    className: "btn btn-300 btn-block btn-inverted external-uploadLabel",
    htmlFor: "file"
  }, "LADDA UPP FIL")) : React.createElement(Button, {
    block: true,
    className: "external-prompt-btn",
    inverted: true,
    onClick: handleSignIn,
    size: 300
  }, "LOGGA IN"));
};
setGlobal('svs.components.tipsen.RoutePlayExternal.PlayExternalPrompt', PlayExternalPrompt);

 })(window);